"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLaravelRequestHeaders = void 0;
const enhancedFetch_1 = require("../enhancedFetch");
function getLaravelRequestHeaders(options) {
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
    // File uploads
    if (enhancedFetch_1.isFormData(options.body)) {
        // delete, useFetch will figure it out
        // @ts-ignore
        delete headers['Content-Type'];
    }
    // Echo (websockets)
    // headers['X-Socket-Id'] = Echo.socketId()
    return headers;
}
exports.getLaravelRequestHeaders = getLaravelRequestHeaders;
const getLaravelConfig = () => ({
    formatResponse: (resp) => resp.data,
    beforeRequest: (options) => {
        let { method } = options;
        options.headers = Object.assign(Object.assign({}, getLaravelRequestHeaders(options)), options.headers);
        if (method === 'PUT' && options.body && enhancedFetch_1.isFormData(options.body)) {
            // @ts-ignore
            options.body.append('_method', 'PUT'); // Laravel will read "_method" and convert from POST to PUT. (its needed for files(FormData))
            method = 'POST'; // overwrite
        }
        return Object.assign(Object.assign({}, options), { method });
    },
});
exports.default = getLaravelConfig;
